module.exports = __webpack_public_path__ + "static/media/undraw_a_moment_to_relax_bbpa.8461aa2d.svg";